import React from 'react';
import { useLocation } from 'react-router-dom';
import { OrganizationPageSkeleton, organizationTabFromPath } from './OrganizationPageSkeleton';

/**
 * The Organization skeleton for whichever tab the URL points at — for the
 * places that only know the path: the section layout's Suspense fallback and
 * RouteSkeleton.
 */
export function OrganizationRouteSkeleton(): React.ReactElement {
  const { pathname } = useLocation();
  return <OrganizationPageSkeleton tab={organizationTabFromPath(pathname)} />;
}
